import { render, staticRenderFns } from "./IntegratorTableUpsert.vue?vue&type=template&id=ef8fab52"
import script from "./IntegratorTableUpsert.vue?vue&type=script&lang=ts"
export * from "./IntegratorTableUpsert.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports